/**
 * HTML Utilities
 *
 * Pure functions for HTML escaping and sanitization.
 */

/**
 * Escape HTML to prevent XSS.
 *
 * @param {string} text - Raw text to escape
 * @returns {string} Escaped HTML string
 */
export function escapeHtml(text) {
  if (!text) return "";
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
